<template>
    <el-dialog
        :visible.sync="show"
        append-to-body
        width="60%"
        class="schedule-dlg"
        :before-close="closeDialog"
    >
        <template slot="title">
            <div class="dlg-title color-primary">
                验收标准及描述
            </div>
        </template>
        <div class="container">
            <el-tabs
                v-model="cityTabsValue"
            >
                <el-tab-pane
                    v-for="item in cityTabList"
                    :key="item.cityName"
                    :label="item.cityName"
                    :name="item.cityName"
                />
            </el-tabs>
            <xx-table-pro
                ref="standardTable"
                name="standard-table"
                source="local"
                :pagination="{show: true, pageSize:10}"
                :local-data="standardTableData"
                :columns="columns"
            >
                <template
                    slot="indicatorPicture"
                    slot-scope="{row}"
                >
                    <xx-image
                        v-for="(imgUrl, index) in row.indicatorPicture"
                        :key="index"
                        ref="xxImage"
                        class="img-size"
                        :src="imgUrl"
                        :preview-src-list="[imgUrl]"
                        :is-in-dialog="true"
                        @image-click="editImageViewer"
                    />
                </template>
            </xx-table-pro>
        </div>
        <div
            slot="footer"
            class="dialog-footer"
        >
            <el-button
                type="primary"
                @click="close"
            >
                关闭弹窗
            </el-button>
        </div>
    </el-dialog>
</template>
<script>
import { getStandardDescriptionColumn } from '../config';

export default {
    components: {},
    props: {},
    data() {
        return {
            show: false,
            cityTabsValue: 'defaultTabValue',
            cityTabList: [],
            standardData: [],
            standardTableData: [],
            standardDataMap: new Map(),
        };
    },
    computed: {
        columns() {
            return getStandardDescriptionColumn();
        },
    },
    watch: {
        cityTabsValue(val) {
            if (!val || val === 'defaultTabValue') return;
            if (this.$refs.standardTable) {
                this.$refs.standardTable.currentPage = 1;
            }
            const index = this.standardDataMap.get(val);
            this.standardTableData = this.standardData[index].indicatorDetailDtoList
                ? this.standardData[index].indicatorDetailDtoList : [];
            // 分割图片url
            this.standardTableData.forEach((item) => {
                if (item.indicatorPicture) {
                    if (typeof item.indicatorPicture === 'string') {
                        item.indicatorPicture = item.indicatorPicture.split(',');
                    } else {
                        item.indicatorPicture = item.indicatorPicture.toString().split(',');
                    }
                } else {
                    item.indicatorPicture = [];
                }
            });
        },
    },
    methods: {
        async popup({
            skuId, enquiryId, supplierId, tenderId, groupId,
        } = {}) {
            try {
                const url = enquiryId || tenderId ? '/api/vss/shepherd/enquiry/skuQmsTemplateInfo' : '/api/vss/shepherd/sqm/skuQmsTemplateInfo';
                const params = enquiryId || tenderId ? {
                    skuId,
                    enquiryId: enquiryId || undefined,
                    tenderId: tenderId || undefined,
                } : { skuId, supplierId };
                if (groupId) {
                    params.groupId = groupId || undefined;
                }
                this.standardData = await this.$hPost(url, params);
                if (this.standardData && this.standardData.length >= 1) {
                    this.standardDataMap = new Map(this.standardData.map((item, index) => (
                        [item.cityName, index]
                    )));
                    this.cityTabList = this.standardData.map((item) => ({
                        cityName: item.cityName,
                    }));
                    this.cityTabsValue = this.cityTabList[0].cityName;
                    this.show = true;
                } else {
                    this.show = true;
                }
            } catch (e) {
                this.$message.error(e.message);
            }
        },
        // 重置弹窗数据
        resetDialogData() {
            this.cityTabsValue = 'defaultTabValue';
            this.cityTabList = [];
            this.standardData = [];
            this.standardTableData = [];
            this.standardDataMap = new Map();
        },
        close() {
            this.show = false;
            this.resetDialogData();
        },
        closeDialog(done) {
            this.resetDialogData();
            done();
        },
        editImageViewer(elements) {
            // elements为预览图片元素数组
            if (elements) {
                elements.forEach((item) => {
                    this.imgAddWaterMarker(item, '小象超市-品控标准，不可泄漏或截图');
                });
            }
        },
        // 图片添加水印
        async imgAddWaterMarker(img, str) {
            if (!str) {
                return;
            }
            if (!img.complete) {
                await new Promise((resolve) => {
                    img.onload = resolve;
                });
            }
            const can = document.createElement('canvas');
            const div = document.createElement('div');

            can.width = 300;
            can.height = 200;
            can.style.display = 'none';

            const cans = can.getContext('2d');
            cans.rotate((-15 * Math.PI) / 180);
            cans.font = '14px Microsoft JhengHei';
            cans.fillStyle = 'rgba(17, 17, 17, 0.2)';
            cans.textAlign = 'left';
            cans.textBaseline = 'Middle';
            cans.fillText(str, 0, 80);

            div.style.cssText = 'position: fixed; top: 0; bottom: 0; left: 0; right: 0; pointer-events: none; z-index: 9999;';
            div.style.backgroundImage = `url(${can.toDataURL('image/png')})`;
            img.parentElement.insertBefore(div, img);
        },

    },
};
</script>
<style scoped lang="scss">
.schedule-dlg {
    display: flex;
    justify-content: center;
    align-items: center;
    /deep/ .el-dialog {
        margin: auto !important;
    }
    /deep/ .el-dialog__header {
        background-color: #ffffff;
        height: auto;
        .dlg-title {
            display: flex;
            font-size: 18px;
            color: #409eff;
            letter-spacing: 0;
            line-height: 18px;
            font-weight: 500;
            padding: 24px;
        }
        .el-icon-close {
            font-size: 15px;
            color: #000000;
        }
    }
    /deep/ .el-dialog__body {
        padding: 0 12px;
    }
    /deep/ .el-dialog__footer {
        background-color: #ffffff;
    }
    .container {
        .img-size {
            width: 35px;
            height: 35px;
            margin-right: 5px;
        }
    }
    .dialog-footer {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
